(() => {
  'use strict';
  const dialog = document.getElementById('tf-mini-card');
  if (!dialog) return;
  const strings = JSON.parse(document.getElementById('tf-mini-strings').textContent);
  const find = selector => dialog.querySelector(selector);
  const add = find('[data-mini-add]'), wish = find('[data-mini-wish]');
  const status = find('#tf-mini-status'), options = find('[data-mini-options]');
  const price = find('[data-mini-price]'), image = find('[data-mini-image]');
  const details = find('[data-mini-details]');
  let trigger, product, selection = [], variant, controller, generation = 0, scrollState;
  let adding = false;
  const attempts = new Map();
  function setImage(src, title) {
    image.hidden = !src;
    if (src) image.src = src; else image.removeAttribute('src');
    image.alt = title;
  }
  function update() {
    variant = product.variants.find(v => v.options.every((value, index) => value === selection[index]));
    price.textContent = variant ? TFShopify.money(variant.price) : strings.unavailable;
    const attempt = variant && attempts.get(variant.id);
    add.disabled = adding || !variant?.available || Boolean(attempt?.uncertain);
    add.textContent = adding ? strings.adding : variant?.available ? strings.add : variant ? strings.sold_out : strings.unavailable;
    options.querySelectorAll('[data-option-index]').forEach(button => {
      const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
      const chosen = selection[index] === value;
      button.classList.toggle('selected', chosen);
      button.setAttribute('aria-pressed', String(chosen));
      button.disabled = adding;
    });
    setImage(variant?.featured_image?.src || product.featured_image || trigger.dataset.productImage, product.title);
    const url = new URL(trigger.dataset.productUrl, location.origin);
    if (variant) url.searchParams.set('variant', variant.id);
    details.href = url.pathname + url.search;
  }
  async function open(pin) {
    controller?.abort(); controller = new AbortController();
    const version = ++generation;
    trigger = pin; product = null; variant = null; selection = [];
    options.replaceChildren(); status.hidden = true;
    find('#tf-mini-title').textContent = pin.dataset.productTitle || strings.loading;
    find('[data-mini-series]').textContent = pin.dataset.productSeries || '';
    setImage(pin.dataset.productImage, pin.dataset.productTitle || '');
    price.textContent = strings.loading; add.textContent = strings.loading; add.disabled = true;
    wish.disabled = true; wish.removeAttribute('data-like'); wish.removeAttribute('data-product-id'); wish.setAttribute('aria-pressed', 'false');
    details.hidden = true;
    scrollState = { y: scrollY, body: document.body.style.cssText, overflow: document.documentElement.style.overflow };
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed'; document.body.style.top = -scrollState.y + 'px'; document.body.style.width = '100%';
    pin.classList.add('active'); pin.setAttribute('aria-expanded', 'true');
    if (!pin.dataset.productUrl) { price.textContent = strings.coming; add.textContent = strings.coming; return; }
    const url = new URL(pin.dataset.productUrl, location.origin);
    details.href = url.pathname + url.search; details.hidden = false;
    try {
      const response = await fetch(url.pathname + '.js', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(strings.error);
      const loaded = await response.json();
      if (version !== generation || !dialog.open) return;
      product = loaded;
      const initial = product.variants.find(v => v.available) || product.variants[0];
      selection = [...initial.options];
      find('#tf-mini-title').textContent = product.title;
      product.options.forEach((option, index) => {
        if (product.variants.length === 1 && initial.title === 'Default Title') return;
        const group = document.createElement('div'); group.className = 'section'; group.setAttribute('role', 'group'); group.setAttribute('aria-label', option.name);
        const label = document.createElement('p'); label.className = 'section-label'; label.textContent = option.name;
        const grid = document.createElement('div'); grid.className = 'size-grid';
        [...new Set(product.variants.map(v => v.options[index]))].forEach(value => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'size-btn'; button.textContent = value;
          button.dataset.optionIndex = index; button.dataset.optionValue = value;
          button.addEventListener('click', () => { selection[index] = value; status.hidden = true; update(); });
          grid.append(button);
        });
        group.append(label, grid); options.append(group);
      });
      wish.dataset.like = product.handle; wish.dataset.productId = 'gid://shopify/Product/' + product.id; wish.disabled = false;
      document.dispatchEvent(new Event('tf:mini:ready'));
      update();
    } catch (error) {
      if (version !== generation || error.name === 'AbortError') return;
      price.textContent = ''; status.textContent = strings.error; status.hidden = false; add.textContent = strings.unavailable;
    }
  }
  document.addEventListener('click', event => {
    const pin = event.target.closest('[data-mini-product]');
    if (!pin || dialog.open || adding) return;
    event.preventDefault(); open(pin);
  });
  function closeCard() { dialog.close(); restorePage(); }
  find('[data-mini-close]').addEventListener('click', closeCard);
  let outside = false;
  const isOutside = e => { const b = dialog.getBoundingClientRect(); return e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom; };
  dialog.addEventListener('pointerdown', e => { outside = e.target === dialog && isOutside(e); });
  dialog.addEventListener('click', e => { if (outside && e.target === dialog && isOutside(e)) closeCard(); outside = false; });
  function restorePage() {
    if (dialog.open || !scrollState) return;
    ++generation; controller?.abort();
    if (scrollState) { document.body.style.cssText = scrollState.body; document.documentElement.style.overflow = scrollState.overflow; window.scrollTo(0, scrollState.y); scrollState = null; }
    trigger?.classList.remove('active'); trigger?.setAttribute('aria-expanded', 'false'); trigger?.focus({ preventScroll: true });
  }
  dialog.addEventListener('close', restorePage);
  add.addEventListener('click', async () => {
    if (add.disabled || adding || !variant?.available) return;
    const selected = variant, version = generation;
    const attempt = attempts.get(selected.id) || { id: crypto.randomUUID() };
    attempts.set(selected.id, attempt); adding = true; status.hidden = true; update();
    try {
      await TFShopify.add([{ id: selected.id, quantity: 1 }], false, attempt);
      attempts.delete(selected.id);
      if (dialog.open) {
        const closed = new Promise(resolve => dialog.addEventListener('close', resolve, { once: true }));
        dialog.close(); await closed;
      }
    } catch (error) {
      if (version === generation) { status.textContent = error.message; status.hidden = false; }
    } finally { adding = false; if (dialog.open && product) update(); }
  });
})();
